export default [
    {
        text: "ID",
        value: "customerCctvUploadId",
        class: "wrap-headers",
        tooltip: "Upload ID"
    },
    {
        text: "Date",
        value: "createdDate",
        class: "wrap-headers",
        tooltip: "Date of upload"
    },
    {
        text: "Uploaded By",
        value: "userEmail",
        class: "wrap-headers"
    },
    {
        text: "Type",
        value: "type",
        class: "wrap-headers",
        tooltip: "Type of upload"
    },
    {
        text: "Inspection Purpose",
        value: "inspectionPurpose",
        class: "wrap-headers",
        tooltip: "CCTV survey inspection purpose"
    },
    {
        text: "Client Contact",
        value: "clientContactId",
        class: "wrap-headers",
        tooltip: "Authority contact email"
    },
    {
        text: "Project Name",
        value: "projectName",
        class: "wrap-headers"
    },
    {
        text: "Project Reference",
        value: "projectReference",
        class: "wrap-headers",
        tooltip: "Additional reference for project"
    },
    {
        text: "Expected Project Meters(m)",
        value: "expectedMeter",
        class: "wrap-headers"
    },
    {
        text: "Upload Meters (m)",
        value: "uploadedMeter",
        class: "wrap-headers"
    },
    {
        text: "Description & Comments",
        value: "comment",
        class: "wrap-headers",
        tooltip: "Description, comments, timeframes, and other requirements"
    },
    {
        text: "Status",
        value: "status",
        class: "wrap-headers",
        tooltip:
            "<span>Pending - awaiting approval by authority<br>Approved - by authority awaiting processing<br>Processing - processing of survey data<br>Complete - reports and data available online</span>"
    },
    {
        text: "Purchase Order",
        value: "purchaseOrder",
        class: "wrap-headers",
        tooltip: "Purchase order supplied by authority"
    },
    {
        text: "Approved Date",
        value: "approvedDate"
    },
    {
        text: "",
        value: "checkbox",
        sortable: false
    }
];
